import type { Components, Theme } from '@mui/material';
import { alertClasses, SvgIcon } from '@mui/material';
import InfoCircleIcon from '@/ui/kit/icons/info-circle.svg';
export const MuiToastAlert = (theme: Theme): Components['MuiAlert'] => ({
  defaultProps: {
    iconMapping: {
      success: <SvgIcon sx={{
        borderRadius: 'var(--corner_radius_m)',
        padding: 'var(--spacing_xxs)',
        fill: theme.palette.approve?.text,
        bgcolor: theme.palette.approve?.bg3
      }} viewBox="0 0 20 20" component={InfoCircleIcon} />,
      info: <SvgIcon sx={{
        borderRadius: 'var(--corner_radius_m)',
        padding: 'var(--spacing_xxs)',
        fill: theme.palette.text?.text,
        bgcolor: theme.palette.background?.bg
      }} component={InfoCircleIcon} />,
      warning: <SvgIcon sx={{
        borderRadius: 'var(--corner_radius_m)',
        padding: 'var(--spacing_xxs)',
        fill: theme.palette.warning__wallfund?.text,
        bgcolor: theme.palette.warning__wallfund?.bg2
      }} component={InfoCircleIcon} />,
      error: <SvgIcon sx={{
        borderRadius: 'var(--corner_radius_m)',
        padding: 'var(--spacing_xxs)',
        fill: theme.palette.critical?.text,
        bgcolor: theme.palette.critical?.bg3
      }} component={InfoCircleIcon} />
    }
  },
  styleOverrides: {
    root: {
      padding: 16,
      backgroundColor: theme.palette.background.bg2,
      border: "1px solid",
      borderColor: theme.palette.stroke?.stroke2,
      color: theme.palette.text.text,
      boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.02), 0px 8px 20px 0px rgba(0, 0, 0, 0.08)',
      borderRadius: 'var(--corner_radius_m)',
      ...theme.typography.bodyMedium__Wallfund
    },
    message: {
      padding: 0,
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      ...theme.typography.bodyMedium__Wallfund
    },
    icon: {
      padding: 0,
      marginLeft: 0,
      marginRight: 8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }
});
export const MuiToastAlertTitle = (theme: Theme): Components['MuiAlertTitle'] => ({
  styleOverrides: {
    root: {
      marginBottom: 0,
      marginTop: 0,
      ...theme.typography.bodyStrong__Wallfund
    }
  }
});